export default "__VITE_ASSET__iuYBsQhK__"